import { useRef } from 'react';

import { UserDto } from '~modules/user/model';

import { authStore } from './auth.store.ts';

interface CheckAuthState {
	isPending: boolean;
	user: UserDto | null;
	error: boolean;
	login: (withInit: boolean) => void;
	logout: () => void;
}

export function useCheckAuth(): CheckAuthState {
	const { isPending, user, login, logout, error } = authStore();
	const ref = useRef(false);

	if (!ref.current && isPending) {
		if (self.location.href.endsWith('/denied')) {
			self.location.assign('/');
		}
		ref.current = true;
		login(true);
	}

	return { isPending, user, logout, login, error };
}
